<template>
  <div class="body">
    <el-form :rules="rules" ref="loginForm" :model="loginForm" class="loginContainer" label-width="90px">
      <h3 class="loginTitle">
        注册
      </h3>
      <el-form-item prop="userName" label="用户名">
        <el-input type="text" v-model="loginForm.userName" placeholder="手机号" size="large">
        </el-input>
      </el-form-item>
      <el-form-item prop="password" label="密码">
        <el-input type="password" v-model="loginForm.password" placeholder="" size="large">
        </el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword" label="确认密码">
        <el-input type="password" v-model="loginForm.confirmPassword" placeholder="" size="large">
        </el-input>
      </el-form-item>
      <slideVerify @success="onVerifySuccess">
      </slideVerify>
      <el-form-item v-show="codeShow===true" prop="code" label="验证码" size="large">
        <el-input type="text" v-model="loginForm.code" style="width: 45%">
        </el-input>
        <el-button :disabled="countdown > 0" @click="startCountdown" type="primary" size="large">
          {{ countdown > 0 ? `${countdown}秒后重试` : '点击获取' }}
        </el-button>
      </el-form-item>
      <el-button type="primary" style="width:100%" @click="submitRegisterUser" size="large">注册</el-button>
    </el-form>
  </div>
</template>

<script>

import router from "@/router";
import slideVerify from "@/components/SlideVerify";
import request from "../utils/request";
import {ElMessage} from "element-plus";

async function registerUser(userName, password) {
  await request.post('/register/', {
    "userName": userName, "password": password
  }, {
    headers: {
      'Content-Type': 'application/json;charset=utf-8'
    }
  }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给items
    if (result.code !== "200" && result.msg !== "") {
      ElMessage.warning(result.msg);
    } else {
      ElMessage.info("注册成功");
      router.push("/login");
    }
  }).catch(error => {
    console.error("register error:" + error);
    ElMessage.info("注册失败");
  });
}


async function sendPhoneConfirmCode(userName) {
  await request.post(
      '/register/generatePhoneConfirmCode',
      {
        "userName": userName,
        "type": "register"
      },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8'
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200" && result.msg !== "") {
          ElMessage.error(result.msg);
        } else {
          ElMessage.warning("验证码已发送，请通过手机查收");
        }
      }).catch(error => {
        console.error("sendPhoneConfirmCode error:" + error);
        // ElMessage.info("系统异常，请联系管理员");
      });
}

let phoneConfirmCodeSuccess = false;
async function checkPhoneConfirmCode(code, userName) {
  await request.get('/register/checkPhoneConfirmCode',
      {
        params: {
          phone: userName,
          code: code,
          type: 'register'
        }
      }).then(response => {
    const result = response.data; // 将接口返回的数据赋值给result
    if (result.code !== "200" && result.msg !== "") {
      ElMessage.warning(result.msg);
    } else {
      ElMessage.warning("验证码校验通过");
      phoneConfirmCodeSuccess = true;
    }
  }).catch(error => {
    console.error("checkPhoneConfirmCode error:" + error);
    // ElMessage.info("系统异常，请联系管理员");
  });
}

export default {
  name: "CreateUserPage",
  components: {slideVerify},
  data() {
    return {
      loginForm: {
        userName: "",
        password: "",
        confirmPassword: "",
        code: ""
      },
      rules: {
        userName: [{required: true, message: "请输入用户名", trigger: "blur"},
          {
            min: 11,
            max: 11,
            message: '长度为11位的手机号数字',
            trigger: 'blur'
          },
          {
            validator: (rule, value, callback) => {
              // 在这里可以访问到this，因此可以获取到extraParam
              if (this.loginForm.userName.match("^1[3-9]\\\\d{9}$")) {
                callback(new Error('手机号不合法'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }
        ],
        password: [{required: true, message: "请输入密码", trigger: "blur"},
          {min: 6, message: '密码长度要大于6', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // 在这里可以访问到this，因此可以获取到extraParam
              if (this.loginForm.confirmPassword !== "" && value !== this.loginForm.confirmPassword) {
                callback(new Error('密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }],

        confirmPassword: [{required: true, message: "请输入确认密码", trigger: "blur"},
          {min: 6, message: '密码长度要大于6', trigger: 'blur'},
          {
            validator: (rule, value, callback) => {
              // 在这里可以访问到this，因此可以获取到extraParam
              if (this.loginForm.password !== "" && value !== this.loginForm.password) {
                callback(new Error('密码不一致'))
              } else {
                callback()
              }
            }, trigger: 'blur'
          }],

        code: [{required: true, message: "请输入验证码", trigger: "blur"},
          {min: 6, message: '验证码为6位数字', trigger: 'blur'}],
      },
      codeShow: false,
      countdown: 0, // 初始倒计时秒数
      timer: null, // 计时器
    }
  },


  methods: {
    onVerifySuccess() {
      this.codeShow = true
    },
    async startCountdown() {
      if (this.timer) return;
      this.countdown = 60; // 设置倒计时总时间

      if (this.loginForm.userName === "" || this.loginForm.userName.match("^1[3-9]\\\\d{9}$")) {
        this.$message.error("手机号不合法，请重新输入")
      } else {
        await sendPhoneConfirmCode(this.loginForm.userName);
      }
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },

    submitRegisterUser() {
      this.$refs.loginForm.validate(async (valid) => {
        if (valid) {
          await checkPhoneConfirmCode(this.loginForm.code, this.loginForm.userName);
          if (phoneConfirmCodeSuccess) {
            await registerUser(this.loginForm.userName, this.loginForm.password);
          }
        } else {
          this.$message.error('注册出错，请重新输入');
        }
      });
    }
  }
}


</script>

<style scoped>

.loginContainer {
  border-radius: 15px;
  background-clip: padding-box;
  text-align: left;
  margin: auto;
  margin-top: 180px;
  width: 350px;
  padding: 15px 35px 15px 35px;
  background: #e9e9ea;
  border: 1px solid blueviolet;
  box-shadow: 0 0 25px #f885ff;
}

.loginTitle {
  margin: 0px auto 48px auto;
  text-align: center;
  font-size: 40px;
}

.loginRemember {
  text-align: left;
  margin: 0px 0px 15px 0px;
}

.body {
  width: 100%;
  height: 100%;
  background-image: url("@/assets/picture/loginBackground.jpg");
  background-size: 100%;
  overflow: hidden;
  position: absolute;
  display: flex;
}

.el-form {
  width: 300px;
  margin: 100px auto;
}
</style>
